// extracted by mini-css-extract-plugin
export default {"body":"CustomTable_body__6aPZE"};